function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "exe"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fill: "#EFF4F6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "fold-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "fold",
  fill: "#D5E1E5",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))))))), /*#__PURE__*/React.createElement("g", {
  id: "window-code",
  transform: "translate(6.250000, 15.000000)",
  fill: "#637282",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.130276,6.34895831 L2.06290584,0.359375 C1.57751623,-0.119791667 0.849431819,-0.119791667 0.364042207,0.359375 C-0.121347402,0.838541669 -0.121347402,1.55729167 0.364042207,2.03645833 L5.58198052,7.1875 L0.364042207,12.3385417 C-0.121347402,12.8177083 -0.121347402,13.5364583 0.364042207,14.015625 C0.606737013,14.2552083 0.849431819,14.375 1.21347402,14.375 C1.57751623,14.375 1.82021104,14.2552083 2.06290584,14.015625 L8.130276,8.02604169 C8.61566556,7.546875 8.61566556,6.828125 8.130276,6.34895831 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 8.49431819,
  y: 11.7613636,
  width: 8.49431819,
  height: 2.61363636
}))));

var SvgExe = function SvgExe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exe.d8f80193.svg";
export { ForwardRef as ReactComponent };